import { Software } from '~/lib/ApiModel';
import { orderBy } from './ArrayHelper';

export function softwareIsBinary(s: Software) {
    return (
        s.minimum_licence_count === s.maximum_licence_count ||
        (s.minimum_licence_count === 0 && s.maximum_licence_count === 1)
    );
}

export type SoftwareGroup = {
    name: string;
    software: Software[];
};

export function softwareGroups(software: Software[]): SoftwareGroup[] {
    //create groups
    const softwareGroups = new Map<string, Software[]>();
    for (const s of software) {
        const group = s.group ?? s.name;
        softwareGroups.set(group, [...(softwareGroups.get(group) ?? []), s]);
    }

    //sort and return groups
    const result: SoftwareGroup[] = [];
    for (const [name, groupMembers] of Array.from(softwareGroups.entries())) {
        result.push({ name: name, software: orderBy(groupMembers, (s) => s.cost_per_licence_per_month) });
    }
    return orderBy(result, (g) => g.name);
}
